/**
 * Filters out duplicate array elements based on their `value` property.
 *
 * @template T - The type of element, must have a `value` property of any type.
 * @param {T[]} elements - The array of elements to filter.
 * @returns {T[]} A new array containing only unique elements by `value`.
 */
export function filterUnique<T extends { value: unknown }>(elements: T[]): T[] {
  const seen = new Set()
  return elements.filter((element) => {
    if (seen.has(element.value)) {
      return false
    }
    seen.add(element.value)
    return true
  })
}
